import "./_freecontent-archive-styles.scss";

import './freecontent-archive';
